module.exports = __webpack_public_path__ + "img/lincoln.181cec34.png";